export class Prompt {
	promptId: string;
	createdById: string;
	caseId: string;
	title: string;
	fullPrompt: string;
	isPinned: boolean;
	isShared: boolean;
	dateTimeCreated: Date;
	promptType: number;
	lifeCycle: boolean;
}
